<template>
<div>
    <div class="ibox-content">
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>Nombre</label>
                    <div class="input-group">
                        <input placeholder="Nombre" v-model="tipoCita.nombre" type="text" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Abreviatura</label>
                    <div class="input-group">
                        <input placeholder="Abreviatura" v-model="tipoCita.abrev" type="text" class="form-control" />
                    </div>
                </div>
            </div>
        </div>
        <hr v-if="list.length > 0" />
        <div class="row" v-for="(item, index) in list" :key="index">
            <div class="col-md-6">
                <div class="form-group">
                    <label>Establecimiento {{index+1}}</label>
                    <div class="input-group">
                        <multiselect placeholder="Selecciona establecimiento" label="nombre" :multiple="true" :taggable="true" track-by="id" v-model="item.establecimientos" :options="establecimientos_list"></multiselect>
                        <!-- <input placeholder="Nombre" v-model="item.establecimiento" type="text" class="form-control" /> -->
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Estrategia {{index+1}}</label>
                    <div class="input-group">
                        <select class="custom-select" v-model="item.estrategia">
                            <option disabled value="">Seleccione un elemento</option>
                            <option v-for="(estrategia, index3) in estrategias_list" :key="index3" v-bind:value="estrategia.id">
                                {{ estrategia.nombre }}
                            </option>
                        </select>
                        <!-- <input placeholder="Abreviatura" v-model="item.estrategia" type="text" class="form-control" /> -->
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="form-group">
                    <label>Eliminar</label>
                    <div class="input-group">
                        <button class="btn btn-secondary" @click="eliminar(index)">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <a href="javascript:void(0)" @click="add">Añadir Estrategia</a>
            </div>
        </div>
    </div>
    <div class="ibox-footer">
        <div class="row">
            <div class="col-md-4 offset-md-8">
                <div class="btn-group float-right">
                    <button type="submit" class="btn btn-primary" @click="save">
                        <i class="fal fa-save"></i> Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    components: { Multiselect },
    props: ["tipo_cita", "establecimientos", "estrategias","test_ab"],
    data() {
        return {
            establecimientos_list: [],
            estrategias_list: [],
            list: [],
            tipoCita: {},
        };
    },
    mounted() {
        this.estrategias_list = JSON.parse(this.estrategias);
        this.establecimientos_list = JSON.parse(this.establecimientos);
        this.tipoCita = JSON.parse(this.tipo_cita);
        let establecimientos = [];

        console.log(JSON.parse(this.test_ab));
        this.list = JSON.parse(this.test_ab).map(element => {
            establecimientos = [];
            const map_establecimientos = new Map();
            for (const item of element.establecimientos) {
                if (!map_establecimientos.has(item.id_establecimiento)) {
                    map_establecimientos.set(item.id_establecimiento, true); // set any value to Map
                    establecimientos.push(item.establecimiento);
                }
            }
            return {
                establecimientos: establecimientos,
                estrategia: element.estrategia.id,
                id: element.id
            }
        });
    },
    methods: {
        add() {
            let x = {
                establecimientos: this.establecimientos_list,
                estrategia: "",
                id: null
            };
            this.list.push(x);
        },
        save() {
            console.log(this.list);
            let array_objects = [];
            let flag = true;
            let temp = [];
            this.tipoCita["list"] = [];
            let establecimientos = [];

            let cont = 1;
            for (const element of this.list) {
                if (!this.filtrar_vacio(element, cont) || !flag) {
                    flag = false;
                    break;
                }
                establecimientos = [];
                if (flag){
                    for (const element2 of element.establecimientos) {
                        establecimientos.push(element2.id);
                        let obj = {
                            id_establecimiento: element2.id,
                            establecimiento_nombre: element2.nombre,
                            estrategia: element.estrategia,
                            indice: cont
                        };

                        temp = array_objects.filter((filtro => {
                            return filtro.id_establecimiento == obj.id_establecimiento
                        }))

                        if (temp.length > 0) {
                            this.$swal.fire({
                                position: 'center',
                                icon: 'error',
                                title: 'Oops...',
                                text: 'ERROR "' + temp[0].establecimiento_nombre + '" se repite con la misma estrategia en establecimiento ' + temp[0].indice + ' y establecimiento ' + obj.indice + '!',
                                showConfirmButton: true,
                                timer: 5000,

                            });
                            flag = false;
                            break;

                        } else {
                            array_objects.push(obj);
                        }
                    }
                }else{
                    break;
                }                    

                this.tipoCita['list'].push({
                    establecimientos: establecimientos,
                    estrategia: element.estrategia,
                    id: element.id
                });
                cont++;
            }

            // this.list.map((element, index) => {
            //     return {
            //         establecimientos: element.establecimientos,
            //         estrategia: element.estrategia,
            //         id: element.id
            //     };
            // });

            if (!flag) { return; }
            axios
                .post("", this.tipoCita)
                .then((response) => {
                    console.log(response);
                    window.history.back();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        eliminar(index) {
            this.list.splice(index, 1);
        },
        filtrar_vacio(element, index) {
            if (element.establecimientos.length == 0) {
                this.$swal.fire({
                    position: 'top-center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Los establecimientos No.' + (index + 1) + ' no pueden quedar vacios!',
                    showConfirmButton: true,
                    timer: 3000,

                });
                return false;
            }
            if (element.estrategia == "") {
                this.$swal.fire({
                    position: 'top-center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'La estrategia No.' + (index + 1) + ' no puede quedar vacia!',
                    showConfirmButton: true,
                    timer: 3000
                });
                return false;
            }
            return true;
        }
    },
};
</script>
